/*global ajax_object  */

// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; // eslint-disable-line
// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import { jarallax, jarallaxElement } from 'jarallax';
import ScrollOut from 'scroll-out';
/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/divi/example-block/index.js';

/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/elementor/example-widget/index.js';

/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/gutenberg/acf-example-block/index.js';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  $('.video-wrapper').click(function () {
    // Get the specific video inside this wrapper
    const video = $(this).find('video').get(0);

    $(video).attr('controls', true);
    $(this).toggleClass('playing');

    if (this.hasClass('playing')) {
      // Play the video
      video.play();
    } else {
      // Pause the video
      video.pause();
    }
  });

  var $filter = $('.video-filter');

  if ($filter.length) {
    var $selected = $filter.find('.video-filter__selected');
    var $dropdown = $filter.find('.video-filter__dropdown');
    var $options = $filter.find('.video-filter__option');
    var $results = $('#video-results');
    var $loader = $('#video-loading');
    var tax = $filter.data('tax');

    // Toggle dropdown
    $selected.on('click', function (e) {
      e.stopPropagation(); // prevent document click from closing immediately
      $dropdown.toggleClass('active');
      $filter.toggleClass('active-filter');
    });

    // Click on option
    $options.on('click', function (e) {
      e.stopPropagation();

      var value = $(this).data('value');

      $selected.text($(this).text());
      $dropdown.removeClass('active');
      $filter.removeClass('active-filter');

      ajaxFilter(value);
    });

    // Close dropdown if click outside
    $(document).on('click', function (e) {
      if (!$filter.is(e.target) && $filter.has(e.target).length === 0) {
        $dropdown.removeClass('active');
        $filter.removeClass('active-filter');
      }
    });
  }
  function ajaxFilter(value) {
    $loader.show();

    $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      data: {
        action: 'video_ajax_filter',
        taxonomy: tax,
        term: value,
      },
      success: function (html) {
        $loader.hide();
        $results.html(html);
        $('.video-title').matchHeight();
      },
      error: function () {
        $loader.hide();
        $results.html('<p>Error loading videos</p>');
      },
    });
  }

  /**
   * News slider
   */
  $('.js-news-list').slick({
    slidesToShow: 2.3,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  /**
   * Video slider
   */
  $('.js-video-list').slick({
    slidesToShow: 2.3,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  /**
   * Sidebar questions slider
   */
  $('.js-questions-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
  });

  /**
   * Sidebar team slider
   */
  $('.js-team-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 5000,
    pauseOnHover: true,
  });

  /**
   * Attorneys slider
   */
  $('.attorneys-slider').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  /**
   * Sidebar Menu
   */
  $('.sidebar-pages-wrap__title').on('click', function () {
    $(this).toggleClass('active-menu');
    $('.sidebar-pages').slideToggle();
  });
  /**
   * AJAX load reviews by category
   */
  // $(document).on('click', '.review-cat-link', function (e) {
  //   e.preventDefault();
  //   let termId = $(this).data('term');
  //   let $reviewsList = $('#reviews-list');
  //   $reviewsList.html('Loading...');
  //
  //   $.post(
  //     ajax_object.ajax_url,
  //     {
  //       action: 'filter_reviews',
  //       term_id: termId,
  //     },
  //     function (html) {
  //       $reviewsList.html(html);
  //       initScrollOut();
  //     }
  //   );
  // });
  $('.reviews-toggle').on('click', function () {
    $('#review-category-list').toggleClass('open');
  });

  $(document).on('click', '.review-cat-link', function (e) {
    e.preventDefault();

    let termId = $(this).data('term');
    let termName = $(this).text();
    let $reviewsList = $('#reviews-list');

    $reviewsList.html('Loading...');

    $('.reviews-toggle').text(termName);

    $('#review-category-list').removeClass('open');

    $.post(
      ajax_object.ajax_url,
      {
        action: 'filter_reviews',
        term_id: termId,
      },
      function (html) {
        $reviewsList.html(html);
        if (typeof initScrollOut === 'function') {
          initScrollOut();
        }
      }
    );
  });
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  // slider for testimonials
  if ($('.js-testimonials-slider').length) {
    $('.js-testimonials-slider').slick({
      dots: false,
      arrows: true,
      infinite: false,
      // speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      rows: 0,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  jarallaxElement();
  jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.5,
  });

  /**
   * Detect element appearance in viewport
   */
  function initScrollOut() {
    ScrollOut({
      threshold: 0.5,
      once: true,
      onShown: function (element) {
        if ($(element).is('.ease-order')) {
          $(element)
            .find('.ease-order__item')
            .each(function (i) {
              let $this = $(this);
              $(this).attr('data-scroll', '');
              window.setTimeout(function () {
                $this.attr('data-scroll', 'in');
              }, 300 * i);
            });
        }
      },
    });
  }

  initScrollOut();

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});

document.addEventListener('DOMContentLoaded', function () {
  if (document.body.classList.contains('.single')) return;
  if (document.body.classList.contains('.page-template-radio')) return;

  const tocList = document.querySelector('.toggle-content .sidebar-pages');
  if (!tocList) return;

  const postContent = document.querySelector('.entry') || document.querySelector('.biography__content'); // Adjust this selector as needed
  const headings = postContent.querySelectorAll('h2,h3');
  if (!headings.length) {
    const sidebarWrap = document.querySelector('.sidebar-pages-wrap');
    if (sidebarWrap) {
      sidebarWrap.style.display = 'none';
    }
    return;
  }

  headings.forEach((heading, index) => {
    const id = `section-${index + 1}`;
    heading.id = id;

    const text = heading.querySelector('span')
      ? heading.querySelector('span').textContent
      : heading.textContent;

    const li = document.createElement('li');
    li.classList.add('menu-item');

    const a = document.createElement('a');
    a.classList.add('link');

    a.href = `#${id}`;
    a.textContent = text.trim();

    li.appendChild(a);
    tocList.appendChild(li);
  });
});

document.addEventListener('click', function (e) {
  // Find closest anchor with an internal hash link
  const anchor = e.target.closest('a[href^="#"]');
  if (!anchor) return; // not an anchor
  if (anchor.getAttribute('href') === '#') return; // ignore dummy links

  e.preventDefault();

  // Get header height dynamically + extra 50px
  const headerHeight =
    (document.querySelector('.header')?.offsetHeight || 0) + 50;

  const targetId = anchor.getAttribute('href').slice(1);
  const targetElement = document.getElementById(targetId);
  if (!targetElement) return; // no target found

  const elementPosition = targetElement.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.home-hero');
  if (!hero) return;

  const sentinel = document.createElement('div');
  sentinel.classList.add('hero-sentinel');
  sentinel.style.position = 'absolute';
  sentinel.style.bottom = '5vw';
  sentinel.style.width = '1px';
  sentinel.style.height = '1px';
  hero.appendChild(sentinel);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          hero.classList.add('scrolled');
        } else {
          hero.classList.remove('scrolled');
        }
      });
    },
    {
      root: null,
      threshold: 0,
    }
  );

  jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.1,
  });

  const video = document.querySelector('.home-hero__content-video');
  const btn = document.querySelector('.video-play');
  const image = document.querySelector('.home-hero__content-video-wrap .img');

  if (!video || !btn) return;

  btn.addEventListener('click', () => {
    video.play();
    video.setAttribute('controls', '');
    btn.style.display = 'none';
    image.style.display = 'none';
  });

  observer.observe(sentinel);
});

document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.faq-item');
  const btn = document.querySelector('.load-more-button');

  let visible = 5;

  function showItems() {
    items.forEach((item, index) => {
      if (index < visible) {
        item.style.display = 'block';
      }
    });

    if (visible >= items.length) {
      btn.style.display = 'none';
    }
  }

  showItems();

  btn.addEventListener('click', function () {
    visible += 5;
    showItems();
  });
});
